<script lang="ts" setup>
  import RulesPage, { type ScoringRow } from './RulesPage.vue';

  const scoringRows: ScoringRow[] = [
    { outcome: '🎯 40–60% correct guesses', score: '900', tier: 1 },
    { outcome: '🙌 20–40% or 60–80%', score: '600', tier: 2 },
    { outcome: '😅 0–20% or 80–100%', score: '300', tier: 3 },
    { outcome: '💀 0 correct guesses', score: '−300', tier: 'penalty' },
  ];
</script>

<template>
  <RulesPage title="🎧 Choosing" scoring-label="Chooser scoring" :scoring-rows="scoringRows" :outcome-width="70">
    <p>Your screen will tell you when you are the chooser 🎵</p>
    <p>You choose a song via a text search, similar to how you would do it in the Spotify app 🔎</p>
    <p>Try to choose a song that ~50% of the other players in the game will guess correctly 🤞</p>
  </RulesPage>
</template>
